var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _rect3, _path7, _path8, _path9, _path10, _circle, _circle2, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOpinionServiceBody2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 199,
    viewBox: "0 0 161 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.488 61.9619C131.229 61.9619 143.163 71.4188 146.304 84.7963L159.563 141.271C161.921 151.312 154.301 160.928 143.987 160.928H81.5996L74.2489 178.569L24.4324 160.866C14.6485 160.014 7.79295 150.466 10.4085 140.763L26.8649 79.7153C29.6887 69.2402 39.1887 61.9619 50.0378 61.9619H117.488Z",
    fill: "#1F2E3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2148 152.65L73.7235 154.439L82.7898 165.074L93.9479 159.146C93.9479 159.146 97.2212 160.818 97.5743 161.034C99.234 162.049 100.947 162.23 102.466 162.013C104.682 161.696 104.637 159.017 102.714 157.871L97.5115 154.769C94.4158 152.923 90.7877 152.177 87.2148 152.65Z",
    fill: "#FFDCD5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.7041,
    y: 144.993,
    width: 40.011,
    height: 4.21168,
    transform: "rotate(55.0435 88.7041 144.993)",
    fill: "#3A7EFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8984 156.388L108.698 164.518C110.216 164.873 111.16 166.391 110.805 167.91C110.45 169.428 108.932 170.372 107.413 170.017L72.6137 161.887L73.8984 156.388Z",
    fill: "#FFDCD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2451 159.985L102.009 169.979C103.605 170.534 104.449 172.277 103.895 173.872C103.341 175.468 101.597 176.312 100.002 175.758L71.2374 165.764L73.2451 159.985Z",
    fill: "#FFDCD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0918 165.713L97.7913 174.989C99.2643 175.501 100.043 177.11 99.5317 178.583C99.0199 180.056 97.411 180.835 95.938 180.324L69.2385 171.047L71.0918 165.713Z",
    fill: "#FFDCD5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0244 170.972L94.5567 179.843C96.0297 180.354 96.8089 181.963 96.2971 183.436C95.7854 184.909 94.1764 185.689 92.7034 185.177L67.1711 176.306L69.0244 170.972Z",
    fill: "#FFDCD5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.8965,
    y: 154.701,
    width: 28.5484,
    height: 10.8444,
    transform: "rotate(18.7433 71.8965 154.701)",
    fill: "#FFDCD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.3528,
    height: 24.2884,
    transform: "matrix(-0.933912 -0.357504 -0.357504 0.933912 76.4531 153.852)",
    fill: "#1F2E3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.073 182.1L108.173 180.201L111.628 177.785L112.073 182.1Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9785 31.215C53.5197 21.5378 61.0131 12.8301 70.7997 12.8301H99.7481C109.528 12.8301 117.02 21.5265 115.572 31.1986L110.994 61.7815C110.115 67.6574 105.068 72.0051 99.1264 72.0051H71.4541C65.5174 72.0051 60.473 67.6641 59.5881 61.7938L54.9785 31.215Z",
    fill: "#FFDCD5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.172 59.9716C76.2711 59.8622 77.2508 60.6645 77.3603 61.7636L77.7948 66.127C77.9042 67.2261 77.1019 68.2058 76.0028 68.3153C74.9037 68.4247 73.9239 67.6224 73.8145 66.5233L73.38 62.1599C73.2705 61.0608 74.0728 60.0811 75.172 59.9716Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7958 59.9716C94.6967 59.8622 93.7169 60.6645 93.6075 61.7636L93.173 66.127C93.0636 67.2261 93.8659 68.2058 94.965 68.3153C96.0641 68.4247 97.0439 67.6224 97.1533 66.5233L97.5878 62.1599C97.6973 61.0608 96.895 60.0811 95.7958 59.9716Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.3812,
    cy: 162.656,
    r: 2.67027,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8802,
    cy: 166.84,
    r: 2.67027,
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.921 104.521L72.6504 71.9875L97.1916 71.9875L84.921 104.521Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8002 12.8301C61.0136 12.8301 53.5201 21.5378 54.9789 31.215L59.3412 60.1528L96.4049 49.4697L111.897 55.7533L115.572 31.1986C117.02 21.5265 109.528 12.8301 99.7485 12.8301H70.8002Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8387 94.1349L85.632 76.8175L88.6461 71.9873L82.1332 71.9873L85.1467 76.8165L81.6318 95.7982L84.9216 104.52L88.8387 94.1349Z",
    fill: "#3A7EFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpinionServiceBody2Mobile);
export default __webpack_public_path__ + "static/media/IcOpinionServiceBody2Mobile.db3416da3d05239105d595f6dec5107a.svg";
export { ForwardRef as ReactComponent };